import apiClient from '@u/apiClient'
import GetPaymentModeListController from '@/wayfinder/actions/App/Http/Controllers/PaymentMode/GetPaymentModeListController'
import GetPaymentModeByIdController from '@/wayfinder/actions/App/Http/Controllers/PaymentMode/GetPaymentModeByIdController'
import GetPaymentModeActivitiesByIdController from '@/wayfinder/actions/App/Http/Controllers/PaymentMode/GetPaymentModeActivitiesByIdController'
import CreatePaymentModeController from '@/wayfinder/actions/App/Http/Controllers/PaymentMode/CreatePaymentModeController'
import UpdatePaymentModeController from '@/wayfinder/actions/App/Http/Controllers/PaymentMode/UpdatePaymentModeController'
import DeletePaymentModeController from '@/wayfinder/actions/App/Http/Controllers/PaymentMode/DeletePaymentModeController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'

export default {
  // region Fetch
  fetchPaymentModeList: ({ commit }) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetPaymentModeListController.get())
        .then((response) => {
          commit('setPaymentModeList', response.data.payment_modes)
          commit('setPaymentModeMetadata', response.data.metadata)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchPaymentModeById: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetPaymentModeByIdController.get({ payment_mode: payload.id }))
        .then((response) => {
          commit('setPaymentMode', response.data.payment_mode)
          commit('setPaymentModeMetadata', response.data.metadata)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchNewPaymentMode({ commit }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetNewModelController.get({ query: { model: 'paymentMode' } }))
        .then((response) => {
          commit('setPaymentMode', response.data.paymentMode)
          commit('setPaymentModeMetadata', response.data.metadata)
          // resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchPaymentModeActivityByPaymentModeID({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetPaymentModeActivitiesByIdController.get({
            payment_mode: payload.payment_mode_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  // endregion

  // region store
  storePaymentMode: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreatePaymentModeController.post(), payload.payment_mode)
        .then((response) => {
          commit('setPaymentMode', response.data.payment_mode)
          commit('setPaymentModeMetadata', response.data.metadata)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region update
  updatePaymentMode: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdatePaymentModeController.put({ payment_mode: payload.id }),
          payload.payment_mode
        )
        .then((response) => {
          commit('setPaymentMode', response.data.payment_mode)
          commit('setPaymentModeMetadata', response.data.metadata)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion
  // region delete
  deletePaymentModeById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeletePaymentModeController.delete.delete({
            payment_mode: payload.id
          })
        )
        .then((response) => {
          commit('setPaymentModeList', response.data.payment_modes)
          commit('setPaymentModeMetadata', response.data.metadata)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region undoDelete
  undoDeletePaymentModeById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeletePaymentModeController.undo.get({ payment_mode: payload.id })
        )
        .then((response) => {
          commit('setPaymentModeList', response.data.payment_modes)
          commit('setPaymentModeMetadata', response.data.metadata)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
  // endregion
}
